/**
 * BANCADA DA JANELA DE GERAR — só em desenvolvimento (T25, 13/10/2026).
 *
 * O editor fica atrás do login, e o agente que constrói a janela não digita senha. Esta página abre
 * a janela com uma conta de exemplo para medir o layout (sem rolagem a 1366×768) no navegador local.
 * A rota só existe quando `NODE_ENV === "development"` — o site no ar não a tem.
 */
import { useState } from "react";
import GenerateImage from "../pages/criar-comic/generate-image";
import AppUser from "../api/app-user.class";
import { PopUpInfo } from "../components/confirm-pop-up";
import { CENARIOS_PRONTOS } from "../classes/cenarios-prontos";
import personagem from "./personagem-de-amostra.png";

const USUARIO = new AppUser({
  id: "",
  _U: "",
  name: "Conta de exemplo",
  email: "",
  city: "",
  educationalInstitution: "",
  birthDate: "",
  comics: [],
  generatedImages: {},
  imgs: Object.fromEntries([
    ["p1", { type: "characters", url: personagem, createdAt: 1, descritivo: "" }],
    ...CENARIOS_PRONTOS.slice(0, 5).map((c, i) => [`c${i}`, { type: "characters", url: c.url, createdAt: 2 + i }]),
  ]),
});

export default function BancadaDaJanela() {
  const [, setPopUp] = useState<PopUpInfo | null>(null);
  const [aberta, setAberta] = useState(true);
  return (
    <main style={{ padding: 24 }}>
      <button type="button" onClick={() => setAberta(true)}>
        Abrir a janela
      </button>
      {aberta && <GenerateImage close={() => setAberta(false)} user={USUARIO} setPopUpInfo={setPopUp} category="characters" />}
    </main>
  );
}
